import {
  styled,
  Text,
  TokenTextAppearance,
  TextTag,
} from '@volkswagen-onehub/components-core';
import React, {useEffect, useState} from 'react';
import {getLang, getTranslations} from '../translations';
import {useParams} from 'react-router-dom';

const TextWrapper = styled.div<{lang?: string}>`
  p {
    padding: 10px 0;
  }
`;

const FavouritesHeader = () => {
  const {labels} = getTranslations();
  const lang = getLang();
  const [copy, setCopy] = useState<string | null>(null);
  const [subCopy, setSubCopy] = useState<string | null>(null);
  const params = useParams();

  useEffect(() => {
    if (!params.ulid) {
      setCopy(labels.my_favourites);
      setSubCopy(labels.my_favourites_copy);
    } else {
      setCopy(labels.share.title.shared);
      setSubCopy(labels.share.copy.shared);
    }
  }, []);

  return (
    <TextWrapper lang={lang}>
      <Text
        tag={TextTag.h2}
        appearance={TokenTextAppearance.headline500}
        bold
      >
        {copy}
      </Text>

      <Text tag={TextTag.p} appearance={TokenTextAppearance.copy200}>{subCopy}</Text>
    </TextWrapper>
  );
};

export default FavouritesHeader;
